var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("HOME SCREEN MANAGER")
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "widget-content" }, [
        _c("div", { staticClass: "company-banner" }, [
          _c("img", {
            attrs: {
              src: _vm.url_banner || require("@/assets/img/banner-dummy.png"),
              alt: "company-banner"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "banner-container" }),
          _vm._v(" "),
          _c("button", { on: { click: _vm.showPopupChangeBanner } }, [
            _c("i", { staticClass: "fa fa-pencil-square-o" }),
            _vm._v("\n        Change Banner\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-officeless-home" },
          [
            _vm.profile_data
              ? _c("div", { staticClass: "profile-box" }, [
                  _c("div", { staticClass: "profile-images inline--block" }, [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.profile_data.photo_url ||
                          require("@/assets/img/profile-dummy.png")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline--block" }, [
                    _vm.organigramName
                      ? _c("div", { staticClass: "profile-name" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.profile_data.first_name +
                                  " " +
                                  _vm.profile_data.last_name
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " + _vm._s(_vm.organigramName) + "\n        "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "my-application" }, [
              _c("div", { staticClass: "title" }, [_vm._v("MY APPLICATIONS")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "appliaction-list" },
                _vm._l(8, function(i) {
                  return _c("div", { key: i, staticClass: "application" })
                })
              )
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("j-widget-list", {
                      attrs: {
                        "data-widget-list": _vm.dataWidgetDetailLeft,
                        position: 1
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("j-widget-list", {
                      attrs: {
                        "data-widget-list": _vm.dataWidgetDetailRight,
                        position: 2
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalBanner",
          staticClass: "mod-form modal-banner-widget",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("Change Banner")
          ]),
          _vm._v(" "),
          _vm.showModalBanner
            ? _c(
                "div",
                {
                  staticClass:
                    "dropbox-oos d-flex flex-column justify-content-center align-items-center"
                },
                [
                  _c("input", {
                    staticClass: "input-file",
                    attrs: { type: "file" },
                    on: {
                      change: function($event) {
                        _vm.handleFileUpload($event, true)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/form-data/file-dropbox.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "label-dropbox" }, [
                    _vm._v("Drop your document here, or "),
                    _c("span", [_vm._v("browse")])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "label-required-upload" }, [
            _vm._v("Maximum File Size: 5 MB")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-required-upload" }, [
            _vm._v("Support: JPG, PNG")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-required-upload" }, [
            _vm._v("Size: 1920 x 350px")
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closePopupBanner }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCrop",
          staticClass: "mod-form modal-crop-banner",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _vm.showModalCrop && _vm.fileUrl
            ? _c(
                "div",
                [
                  _c("j-cropping-image", {
                    attrs: {
                      url: _vm.fileUrl,
                      "name-file": _vm.fileName,
                      title: "Banner Cropping"
                    },
                    on: {
                      "save-banner": _vm.saveBanner,
                      "close-modal": _vm.closePopupCrop
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2944f623", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2944f623","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/jWidgetSetting.vue
// module id = null
// module chunks = 